"use client";

import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactDetails = [{
  id: "address",
  title: "Visit Us",
  description: "3914 Ilford Rd, Silver Spring, MD 20906",
  icon: MapPin,
  actionLabel: "Get Directions",
  actionUrl: "https://maps.google.com/?q=3914+Ilford+Rd,+Silver+Spring,+MD+20906",
  isExternal: true
}, {
  id: "phone",
  title: "Call Us",
  description: "301-477-9779",
  icon: Phone,
  actionLabel: "Call Now",
  actionUrl: "tel:301-477-9779",
  isExternal: false
}, {
  id: "email",
  title: "Email Us",
  description: "info@familyfirstassistedliving.org",
  icon: Mail,
  actionLabel: "Send Message",
  actionUrl: "mailto:info@familyfirstassistedliving.org",
  isExternal: false
}];
export default function Contact() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="contact" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        <div ref={headerRef} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-primary font-semibold tracking-tight mb-4">
            Get in Touch
          </h2>
          <p className="text-lg text-muted-foreground">
            We're here to answer any questions you may have about our care services or to schedule a personal tour of our home.
          </p>
        </div>

        {}
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-12 mb-20 transition-all duration-1000 delay-150 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
          
          
          
          
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {contactDetails.map((item, i) => <div data-index={i} key={item.id} className="h-full">
              <Card className="h-full border-none shadow-sm hover:shadow-md transition-shadow duration-300 bg-card rounded-3xl overflow-hidden group">
                <CardContent className="p-8 md:p-10 flex flex-col items-center text-center h-full">
                  
                  <div className="bg-secondary/10 p-5 rounded-full mb-6 group-hover:scale-110 transition-transform duration-300 ease-out">
                    <item.icon className="w-8 h-8 text-secondary" strokeWidth={1.5} />
                  </div>
                  
                  <h3 className="text-2xl font-serif text-primary font-medium mb-3">
                    {item.title}
                  </h3>
                  
                  <p className="text-muted-foreground mb-8 flex-grow text-base leading-relaxed">
                    {item.description}
                  </p>
                  
                  <Button asChild variant="outline" className="w-full rounded-full border-primary/20 text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
                    <Link to={item.actionUrl} newTab={item.isExternal}>
                      {item.actionLabel}
                    </Link>
                  </Button>
                  
                </CardContent>
              </Card>
            </div>)}
        </div>

      </div>
    </section>;
}